// Components
import { GridColDef } from '@mui/x-data-grid'
import { Tooltip, Typography } from '@mui/material'
import dayjs from 'lib/dayjs'

// Custom sort comparator for date fields in MM/DD/YYYY format
const dateSortComparator = (v1: string, v2: string) => {
  // Handle empty/null values
  if (v1 === '-' && v2 === '-') return 0
  if (v1 === '-') return 1
  if (v2 === '-') return -1

  // Parse dates and compare
  const date1 = dayjs(v1, 'MM/DD/YYYY')
  const date2 = dayjs(v2, 'MM/DD/YYYY')

  if (date1.isBefore(date2)) return -1
  if (date1.isAfter(date2)) return 1
  return 0
}

export const createAssetsColumnDefinitions = (): GridColDef[] => [
  {
    field: 'date',
    headerName: 'Date',
    width: 120,
    sortable: true,
    sortComparator: dateSortComparator,
  },
  {
    field: 'time',
    headerName: 'Time',
    width: 100,
    sortable: true,
  },
  {
    field: 'facility',
    headerName: 'Facility',
    width: 120,
    sortable: true,
  },
  {
    field: 'room',
    headerName: 'Room',
    width: 80,
    sortable: true,
  },
  {
    field: 'patientName',
    headerName: 'Patient',
    width: 175,
    sortable: true,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <Typography variant="body2">{params.value}</Typography>
        </Tooltip>
      )
    },
  },
  {
    field: 'patientDOB',
    headerName: 'Patient DOB',
    width: 120,
    sortable: true,
    sortComparator: dateSortComparator,
  },
  {
    field: 'mrn',
    headerName: 'MRN',
    width: 100,
    sortable: true,
  },
  {
    field: 'procedureType',
    headerName: 'Procedure',
    width: 175,
    sortable: true,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <Typography variant="body2">{params.value}</Typography>
        </Tooltip>
      )
    },
  },
  {
    field: 'surgeon',
    headerName: 'Surgeon',
    width: 150,
    sortable: true,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <Typography variant="body2">{params.value}</Typography>
        </Tooltip>
      )
    },
  },
  {
    field: 'scrubTech',
    headerName: 'Scrub Tech',
    width: 150,
    sortable: true,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <Typography variant="body2">{params.value}</Typography>
        </Tooltip>
      )
    },
  },
  {
    field: 'manufacturer',
    headerName: 'Manufacturer',
    width: 175,
    sortable: true,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <Typography variant="body2">{params.value}</Typography>
        </Tooltip>
      )
    },
  },
  {
    field: 'productDescription',
    headerName: 'Product Description',
    width: 250,
    sortable: true,
    // flex: 1,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <Typography variant="body2">{params.value}</Typography>
        </Tooltip>
      )
    },
  },
  {
    field: 'modelNumber',
    headerName: 'Model Number',
    width: 150,
    sortable: true,
  },
  {
    field: 'catalogNumber',
    headerName: 'Catalog Number',
    width: 150,
    sortable: true,
  },
  {
    field: 'lot',
    headerName: 'Lot',
    width: 100,
    sortable: true,
  },
  {
    field: 'serial',
    headerName: 'Serial',
    width: 200,
    sortable: true,
  },
  {
    field: 'expiration',
    headerName: 'Expiration',
    width: 110,
    sortable: true,
    sortComparator: dateSortComparator,
  },
  {
    field: 'udi',
    headerName: 'UDI',
    width: 200,
    sortable: true,
  },
  {
    field: 'disposition',
    headerName: 'Disposition',
    width: 175,
    sortable: true,
  },
  {
    field: 'siteLocation',
    headerName: 'Site Location',
    width: 150,
    sortable: true,
  },
  {
    field: 'implantSite',
    headerName: 'Implant Site',
    width: 150,
    sortable: true,
  },
  {
    field: 'wastedReason',
    headerName: 'Wasted Reason',
    width: 150,
    sortable: true,
  },
  {
    field: 'samplePreparation',
    headerName: 'Sample Preparation',
    width: 150,
    sortable: true,
  },
  {
    field: 'temperatureOk',
    headerName: 'Temperature',
    width: 150,
    sortable: true,
  },
  {
    field: 'packagingOk',
    headerName: 'Packaging',
    width: 150,
    sortable: true,
  },
  {
    field: 'assetType',
    headerName: 'Product Type',
    width: 235,
    sortable: true,
    renderCell: (params) => {
      return (
        <Tooltip title={params.value}>
          <Typography variant="body2">{params.value}</Typography>
        </Tooltip>
      )
    },
  },
  {
    field: 'itemCost',
    headerName: 'Item Cost',
    width: 120,
    sortable: true,
    type: 'number',
    align: 'center',
    valueFormatter: (params) => {
      const value = params.value || 0
      return `$${value.toFixed(2)}`
    },
  },
]
